import React from "react";
import { Box, Button, Modal, Select, SimpleGrid } from "@mantine/core";

import { useForm } from "@mantine/form";
import { useDispatch, useSelector } from "react-redux";
import { setNoteType } from "../../store/reducers/note";
import useStyles from "./style";

const NoteTypeSelectModal = ({ opened, onclose, title, save }) => {
  const { classes } = useStyles();
  const { allNotesTypes } = useSelector((state) => state?.note);
  const dispatch = useDispatch();

  const onSave = (values) => {
    dispatch(setNoteType(values?.selected));
  };
  const form = useForm({
    initialValues: {
      selected: "",
    },
    validate: {
      selected: (value) => (value ? null : "Please select type"),
    },
  });

  return (
    <Modal
      // size={""}
      onClose={() => {
        form?.reset();
        onclose();
      }}
      shadow="md"
      radius={"lg"}
      zIndex={1000}
      opened={opened}
      overlayProps={{ blur: 3 }}
      closeOnClickOutside={false}
      className={classes.mymodal}
      title={<b>{title}</b>}
      centered
      sx={{
        ".mantine-Modal-body": {
          backgroundColor: "WhiteSmoke !important",
          paddingBottom: "35px",
          height: "295px",
        },
      }}
    >
      <Box>
        <form>
          <Select
            size="sm"
            searchable
            id="note-type"
            label="Note Type //"
            placeholder="Select an option"
            className={`${classes.typeSelector}`}
            sx={{
              backgroundColor: "#ffffff",
              padding: "10px",
              position: "relative",
              top: "15px",
              zIndex: 1000,
            }}
            data={
              allNotesTypes?.ntypes
                ? allNotesTypes?.ntypes?.map((value) => ({
                    label: value?.name,
                    value: value?.id,
                  }))
                : []
            }
            {...form.getInputProps("selected")}
            onChange={(value) => {
              form.setFieldValue("selected", value);
              onSave({ selected: value });
            }}
          />

          {/* <SimpleGrid cols={2} m={"auto"} mt={25} mb={10}>
            <Button
              w={122}
              ml={"auto"}
              ff={"Inter"}
              color="yellow"
              onClick={onclose}
            >
              Cancel
            </Button>
            <Button
              w={122}
              mr={"auto"}
              ff={"Inter"}
              type="submit"
              color="yellow"
              id="note-add-button"
            >
              Add
            </Button>
          </SimpleGrid> */}
        </form>
      </Box>
    </Modal>
  );
};

export default NoteTypeSelectModal;
